var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77979 7.16407L11.2495 4.69435V13.25V13.375H11.3745H12.6245H12.7495V13.25V4.69435L15.2192 7.16407L15.3076 7.25246L15.396 7.16407L16.2798 6.28029L16.3682 6.1919L16.2798 6.10351L12.0879 1.91161L11.9995 1.82322L11.9111 1.91161L7.71923 6.10351L7.63084 6.1919L7.71923 6.28029L8.60301 7.16407L8.6914 7.25246L8.77979 7.16407Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6.87504H19.375V7.00004V8.25005V8.37505H19.5H20.625V20.625H3.37501V8.37501H4.50003H4.62503V8.25001V7V6.875H4.50003H2.62501H2.62499C2.2105 6.87504 1.875 7.21053 1.875 7.62501V21.375C1.875 21.7895 2.2105 22.125 2.62501 22.125H21.375C21.7895 22.125 22.125 21.7895 22.125 21.375V7.62501C22.125 7.21053 21.7895 6.87504 21.375 6.87504H19.5Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.85837face6e4c57d4a8d47eef2d9c66b.svg";
export { ForwardRef as ReactComponent };